import {
  columnLabels,
  kundPlaceLabel,
  kundPlacesOf,
  kunds,
} from "@repo/vihangam-yog-shared";

/**
 * Where a booking sits at the Hawan, on the check-in card: its Kund in
 * large type, and the ground in miniature with that Kund marked, so the
 * desk can point a runner the right way. Nothing for a booking with no
 * Kund yet.
 */
export function KundLocator({
  kundPlace,
  inverted,
}: {
  kundPlace: string | null | undefined;
  /** On the green "checked in" card, where text is white. */
  inverted: boolean;
}) {
  const places = kundPlacesOf(kundPlace);
  if (places.length === 0) {
    return null;
  }
  const soft = inverted
    ? "text-white/80"
    : "text-[color:var(--color-ink-soft)]";
  const cell = inverted ? "bg-white/25" : "bg-[color:var(--color-line)]";
  return (
    <div
      className={`mt-4 rounded-xl border p-4 ${
        inverted
          ? "border-white/40"
          : "border-[color:var(--color-line)] bg-[color:var(--color-paper)]"
      }`}
    >
      <p className="text-[24px] leading-tight font-bold">
        {kundPlaceLabel(kundPlace)}
      </p>
      <div
        role="img"
        aria-label={`${kundPlaceLabel(kundPlace)} on the map of the ground, stage at the top`}
        className="mt-3"
      >
        <p
          className={`rounded-sm py-1 text-center text-[11px] font-semibold tracking-[0.3em] ${cell} ${soft}`}
        >
          STAGE
        </p>
        {/* People come in at the front left, beside A1. */}
        <p className={`mt-1.5 text-[11px] tracking-[0.2em] ${soft}`}>
          ENTRANCE, BY A1 ↓
        </p>
        <div className="mt-1.5 grid grid-cols-4 items-start gap-1.5">
          {columnLabels.map((column) => (
            <div key={column.label} className="flex flex-col gap-1">
              <span className={`text-center text-[12px] font-semibold ${soft}`}>
                {column.label}
              </span>
              {kunds
                .filter((kund) => kund.column === column.label)
                .map((kund) =>
                  places.includes(kund.code) ? (
                    <span
                      key={kund.code}
                      className="rounded-sm bg-[color:var(--color-amber)] text-center text-[12px] leading-5 font-bold text-[color:var(--color-bg)]"
                    >
                      {kund.code}
                    </span>
                  ) : (
                    <span
                      key={kund.code}
                      className={`h-5 rounded-sm ${cell}`}
                    />
                  ),
                )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
